import { Stack, Typography, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CreateAnouncement } from './create-announcement'
import { SupplierAnnouncementTable } from './supplier-announcement-table'
import { CreateTopicSection } from './create-topic-section'
import { ITender, ITenderNotificationsPoll } from 'types/tender'
import { ApplicationChatSection } from './application-chat-section'
import { useUserCurrentQuery } from 'services/users'
import { EOrganizationType } from 'types/users'
import { Loading } from 'components/Loading'

type Props = {
  tender: ITender
  pollData?: ITenderNotificationsPoll
}

export const QuestionAndAnswers = ({ tender, pollData }: Props) => {
  const { t } = useTranslation()
  const { data: currentUser, isLoading } = useUserCurrentQuery()

  if (isLoading) {
    return <Loading fullPage={false} />
  }

  return (
    <Stack spacing={3}>
      {currentUser?.organizationType === EOrganizationType.TENDER_AUTHORITY && (
        <CreateAnouncement tenderId={tender.id} />
      )}
      <SupplierAnnouncementTable tenderId={tender.id} />
      <Stack spacing={1}>
        <Typography fontWeight="bold" variant="h6">
          {`${t('questionAndAnswers')}/${t('complaints')}`}
        </Typography>
        <Divider flexItem />
      </Stack>
      {currentUser && (
        <CreateTopicSection tender={tender} currentUser={currentUser} />
      )}
      <ApplicationChatSection tender={tender} pollData={pollData} />
    </Stack>
  )
}
